import {
  ProductServiceCategoryGqlOutput,
  useProductServiceAllCategoriesLazyQuery,
} from 'zma-react-sdk/product-service'
import { createDataStore, createDataHooks } from '@/shared/stores/create-data-store'
import { flattenCategory } from '@/features/categories/utils/flatten-category'
import { useTenantStore } from '@/stores/tenantStore'

const categoriesStore = createDataStore<Array<ProductServiceCategoryGqlOutput & { level: number }>>({
  dataTransformer: (data) => flattenCategory(data?.productServiceAllCategories || []),
})

const { useData, useClearData, useUpdateData } = createDataHooks(
  () => categoriesStore(),
  () => {
    const { selectedTenantId } = useTenantStore()
    return useProductServiceAllCategoriesLazyQuery({
      context: {
        headers: {
          'x-tenant-id': selectedTenantId,
        },
      },
    })
  }
)

export function useCategoryData() {
  const { data, loading, error } = useData()
  return {
    data: data ?? [],
    loading,
    error,
  }
}

export const useClearCategoryData = useClearData

export function useUpdateCategoryData() {
  const updateData = useUpdateData()
  return (data: ProductServiceCategoryGqlOutput[]) => {
    updateData(flattenCategory(data))
  }
}